/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/member-delimiter-style */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useEffect, useState, FC } from 'react'
import clsx from 'clsx'
import { Button, Container, Grid, Paper, Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'
import { Settings as SettingsStore } from '../../../../stores/settings'
import Orders from './Orders'
import MyContact from './MyContact'
import EmailOpened from './EmailOpened'
// import data from './temp.json'

const useStyles = makeStyles(theme => ({
  rootTab: {
    flexGrow: 1,
    width: '100%',
  },
  root: {
    display: 'flex',
  },
  title: {
    flexGrow: 1,
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  graph: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    fontFamily: 'Hind',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    position: 'relative',
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    fontFamily: 'Hind',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    borderRight: '1px solid gray',
    position: 'relative',
  },
  noBorder: {
    border: 'none',
    padding: 0,
    paddingTop: 5,
  },
  fixedHeight: {
    height: 310,
  },
  prospectContainer: {
    width: '100%',
  },
}))

type ReplyData = {
  name: string
  value: number
}

type OpenData = {
  name: string
  sent: number
  opened: number
}

type DetailedInfo = {
  email: string
  company: string
  status: string
  title: string
  maneuver: string
  dateAdded: Date
  industry: string
  name: string
}

type recentData = {
  Recipient: string
  'Send Date': Date
  Replied: boolean
  Maneuver: string
  Touch: number
  Subject: string
  'Opened Count': string
  Opened: boolean
  Name: string
  Title: string
  Company: string
}

export type ManeuverData = {
  sentEmails: number
  replyData: ReplyData[]
  openData: OpenData[]
  recentData: recentData[]
  addedProspects: number
}

type Props = {
  sentEmails: {
    combined: number
    firstTouch: number
    nurture: number
    followUp: number
  }
  replyData: {
    combined: ReplyData[]
    firstTouch: ReplyData[]
    nurture: ReplyData[]
    followUp: ReplyData[]
  }
  openData: {
    combined: OpenData[]
    firstTouch: OpenData[]
    nurture: OpenData[]
    followUp: OpenData[]
  }
  recentData: {
    combined: recentData[]
    firstTouch: recentData[]
    nurture: recentData[]
    followUp: recentData[]
  }
  prospectsAdded: {
    combined: number
    firstTouch: number
    nurture: number
    followUp: number
    detailedInfo: DetailedInfo[]
  }
  title: string
  settings: SettingsStore
  // eslint-disable-next-line react/no-unused-prop-types
  subscriptionData: any
  currentType: string
  currentStatus: string
  contactsSearch: string
  isActiveUser: boolean
  isActiveCompany: boolean
  reportingData: any
  setCurrentUser: React.Dispatch<any>
  setTypeProp: React.Dispatch<React.SetStateAction<string>>
  tableData: any
  setTableData: React.Dispatch<any>
  setselectedLeadsEmails: any
  setOpenActions: any
}

const Report: FC<Props> = ({
  sentEmails,
  replyData,
  openData,
  recentData,
  title,
  settings,
  prospectsAdded,
  currentType,
  currentStatus,
  isActiveUser,
  isActiveCompany,
  contactsSearch,
  reportingData,
  setCurrentUser,
  setTypeProp,
  tableData,
  setTableData,
  setselectedLeadsEmails,
  setOpenActions,
}): JSX.Element => {
  const classes = useStyles()
  const [selectedManeuver, setManeuver] = useState<ManeuverData>({
    sentEmails: sentEmails.combined,
    replyData: replyData.combined,
    recentData: recentData.combined,
    openData: openData.combined,
    addedProspects: prospectsAdded.combined,
  })
  const [emailsSentData, setEmailsSentData] = useState(
    openData.combined.map((item: any, index: number) => {
      return {
        name: item.name,
        ALL: item.sent,
        REVUP: openData.firstTouch[index].sent,
        ENGAGED: openData.followUp[index].sent,
        REENGAGED: openData.nurture[index].sent,
      }
    }),
  )
  const [emailsOpenedData, setEmailsOpenedData] = useState(
    openData.combined.map((item: any, index: number) => {
      return {
        name: item.name,
        ALL: item.opened,
        REVUP: openData.firstTouch[index].opened,
        ENGAGED: openData.followUp[index].opened,
        REENGAGED: openData.nurture[index].opened,
      }
    }),
  )
  const handleListItemClick = (type): void => {
    // if (type === 'All') {
    //   setManeuver({
    //     sentEmails: data?.sentEmails.combined,
    //     replyData: data?.replyData.combined,
    //     recentData: data?.recentData.combined,
    //     openData: data?.openData.combined,
    //     addedProspects: data?.prospectsAdded.combined,
    //   })
    // } else if (type === 'REV-UP') {
    //   setManeuver({
    //     sentEmails: data?.sentEmails.firstTouch,
    //     replyData: data?.replyData.firstTouch,
    //     recentData: data?.recentData.combined.filter(el => {
    //       return el.Maneuver === 'First Touch'
    //     }),
    //     openData: data?.openData.firstTouch,
    //     addedProspects: data?.prospectsAdded.firstTouch,
    //   })
    // } else if (type === 'ENGAGED') {
    //   setManeuver({
    //     sentEmails: data?.sentEmails.followUp,
    //     replyData: data?.replyData.followUp,
    //     recentData: data?.recentData.combined.filter(el => {
    //       return el.Maneuver === 'Follow Up'
    //     }),
    //     openData: data?.openData.followUp,
    //     addedProspects: data?.prospectsAdded.followUp,
    //   })
    // } else if (type === 'RE-ENGAGE') {
    //   setManeuver({
    //     sentEmails: data?.sentEmails.nurture,
    //     replyData: data?.replyData.nurture,
    //     recentData: data?.recentData.combined.filter(el => {
    //       return el.Maneuver === 'Nurture'
    //     }),
    //     openData: data?.openData.nurture,
    //     addedProspects: data?.prospectsAdded.nurture,
    //   })
    // }
    if (type === 'All') {
      setManeuver({
        sentEmails: sentEmails.combined,
        replyData: replyData.combined,
        recentData: recentData.combined,
        openData: openData.combined,
        addedProspects: prospectsAdded.combined,
      })
    } else if (type === 'REV-UP') {
      setManeuver({
        sentEmails: sentEmails.firstTouch,
        replyData: replyData.firstTouch,
        recentData: recentData.combined.filter(el => {
          return el.Maneuver === 'First Touch'
        }),
        openData: openData.firstTouch,
        addedProspects: prospectsAdded.firstTouch,
      })
    } else if (type === 'ENGAGED') {
      setManeuver({
        sentEmails: sentEmails.followUp,
        replyData: replyData.followUp,
        recentData: recentData.combined.filter(el => {
          return el.Maneuver === 'Follow Up'
        }),
        openData: openData.followUp,
        addedProspects: prospectsAdded.followUp,
      })
    } else if (type === 'RE-ENGAGE') {
      setManeuver({
        sentEmails: sentEmails.nurture,
        replyData: replyData.nurture,
        recentData: recentData.combined.filter(el => {
          return el.Maneuver === 'Nurture'
        }),
        openData: openData.nurture,
        addedProspects: prospectsAdded.nurture,
      })
    }
  }

  const getReplyTotalCount = (): number => {
    return replyData.nurture[1].value + replyData.firstTouch[1].value + replyData.followUp[1].value
  }

  // const getReplyTotalCount = (): number => {
  //   return (
  //     data?.replyData.nurture[1].value +
  //     data?.replyData.firstTouch[1].value +
  //     data?.replyData.followUp[1].value
  //   )
  // }
  const getReplyChartPercent = (value: number): number => {
    const total = getReplyTotalCount()
    return Math.round((value / total) * 100)
  }
  useEffect(() => {
    handleListItemClick(currentType)
  }, [currentType, reportingData])
  useEffect(() => {
    const tempTableData = [...selectedManeuver.recentData]
    setTableData(tempTableData)
  }, [selectedManeuver])
  useEffect(() => {
    // if (selectedManeuver.sentEmails !== data?.sentEmails.combined && currentType === 'All') {
    //   setManeuver({
    //     sentEmails: data?.sentEmails.combined,
    //     replyData: data?.replyData.combined,
    //     recentData: data?.recentData.combined,
    //     openData: data?.openData.combined,
    //     addedProspects: data?.prospectsAdded.combined,
    //   })
    // }
    // if (selectedManeuver.sentEmails !== data?.sentEmails.firstTouch && currentType === 'REV-UP') {
    //   setManeuver({
    //     sentEmails: data?.sentEmails.firstTouch,
    //     replyData: data?.replyData.firstTouch,
    //     recentData: data?.recentData.combined.filter(el => {
    //       return el.Maneuver === 'First Touch'
    //     }),
    //     openData: data?.openData.firstTouch,
    //     addedProspects: data?.prospectsAdded.firstTouch,
    //   })
    // }
    // if (selectedManeuver.sentEmails !== data?.sentEmails.followUp && currentType === 'ENGAGED') {
    //   setManeuver({
    //     sentEmails: data?.sentEmails.followUp,
    //     replyData: data?.replyData.followUp,
    //     recentData: data?.recentData.combined.filter(el => {
    //       return el.Maneuver === 'Follow Up'
    //     }),
    //     openData: data?.openData.followUp,
    //     addedProspects: data?.prospectsAdded.followUp,
    //   })
    // }
    // if (selectedManeuver.sentEmails !== data?.sentEmails.nurture && currentType === 'RE-ENGAGE') {
    //   setManeuver({
    //     sentEmails: data?.sentEmails.nurture,
    //     replyData: data?.replyData.nurture,
    //     recentData: data?.recentData.combined.filter(el => {
    //       return el.Maneuver === 'Nurture'
    //     }),
    //     openData: data?.openData.nurture,
    //     addedProspects: data?.prospectsAdded.nurture,
    //   })
    // }
    // setEmailsSentData(
    //   data?.openData.combined.map((item: any, index: number) => {
    //     return {
    //       name: item.name,
    //       ALL: item.sent,
    //       REVUP: data?.openData.firstTouch[index].sent,
    //       ENGAGED: data?.openData.followUp[index].sent,
    //       REENGAGED: data?.openData.nurture[index].sent,
    //     }
    //   }),
    // )
    // setEmailsOpenedData(
    //   data?.openData.combined.map((item: any, index: number) => {
    //     return {
    //       name: item.name,
    //       ALL: item.opened,
    //       REVUP: data?.openData.firstTouch[index].opened,
    //       ENGAGED: data?.openData.followUp[index].opened,
    //       REENGAGED: data?.openData.nurture[index].opened,
    //     }
    //   }),
    // )
    if (selectedManeuver.sentEmails !== sentEmails.combined && currentType === 'All') {
      setManeuver({
        sentEmails: sentEmails.combined,
        replyData: replyData.combined,
        recentData: recentData.combined,
        openData: openData.combined,
        addedProspects: prospectsAdded.combined,
      })
    }
    if (selectedManeuver.sentEmails !== sentEmails.firstTouch && currentType === 'REV-UP') {
      setManeuver({
        sentEmails: sentEmails.firstTouch,
        replyData: replyData.firstTouch,
        recentData: recentData.combined.filter(el => {
          return el.Maneuver === 'First Touch'
        }),
        openData: openData.firstTouch,
        addedProspects: prospectsAdded.firstTouch,
      })
    }
    if (selectedManeuver.sentEmails !== sentEmails.followUp && currentType === 'ENGAGED') {
      setManeuver({
        sentEmails: sentEmails.followUp,
        replyData: replyData.followUp,
        recentData: recentData.combined.filter(el => {
          return el.Maneuver === 'Follow Up'
        }),
        openData: openData.followUp,
        addedProspects: prospectsAdded.followUp,
      })
    }
    if (selectedManeuver.sentEmails !== sentEmails.nurture && currentType === 'RE-ENGAGE') {
      setManeuver({
        sentEmails: sentEmails.nurture,
        replyData: replyData.nurture,
        recentData: recentData.combined.filter(el => {
          return el.Maneuver === 'Nurture'
        }),
        openData: openData.nurture,
        addedProspects: prospectsAdded.nurture,
      })
    }
    setEmailsSentData(
      openData.combined.map((item: any, index: number) => {
        return {
          name: item.name,
          ALL: item.sent,
          REVUP: openData.firstTouch[index].sent,
          ENGAGED: openData.followUp[index].sent,
          REENGAGED: openData.nurture[index].sent,
        }
      }),
    )
    setEmailsOpenedData(
      openData.combined.map((item: any, index: number) => {
        return {
          name: item.name,
          ALL: item.opened,
          REVUP: openData.firstTouch[index].opened,
          ENGAGED: openData.followUp[index].opened,
          REENGAGED: openData.nurture[index].opened,
        }
      }),
    )
  }, [])
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
  const myRepliesData = [
    {
      title: 'RE-ENGAGE',
      value: getReplyChartPercent(replyData.nurture[1].value),
      color: '#2A2AE0',
    },
    {
      title: 'REV-UP',
      value: getReplyChartPercent(replyData.firstTouch[1].value),
      color: '#E349A8',
    },
    {
      title: 'ENGAGED',
      value: getReplyChartPercent(replyData.followUp[1].value),
      color: '#09B724',
    },
  ]
  // const myRepliesData = [
  //   {
  //     title: 'RE-ENGAGE',
  //     value: getReplyChartPercent(data?.replyData.nurture[1].value),
  //     color: '#2A2AE0',
  //   },
  //   {
  //     title: 'REV-UP',
  //     value: getReplyChartPercent(data?.replyData.firstTouch[1].value),
  //     color: '#E349A8',
  //   },
  //   {
  //     title: 'ENGAGED',
  //     value: getReplyChartPercent(data?.replyData.followUp[1].value),
  //     color: '#09B724',
  //   },
  // ]

  const myContactData = [
    {
      title: 'MAVCONTACTS',
      value: selectedManeuver.recentData.filter(item => item['Added By'] !== 'Maverick').length,
      color: '#F6B870',
    },
    {
      title: 'MY CONTACTS',
      value: selectedManeuver.recentData.filter(item => item['Added By'] !== 'User').length,
      color: '#E349A8',
    },
  ]
  // const myContactData = [
  //   {
  //     title: 'MAVERICKAPP CONTACTS',
  //     value: data?.recentData.combined.filter(item => item['Added By'] === 'Maverick').length,
  //     color: '#F6B870',
  //   },
  //   {
  //     title: 'MY ADDED CONTACTS',
  //     value: data?.recentData.combined.filter(item => item['Added By'] === 'User').length,
  //     color: '#E349A8',
  //   },
  // ]
  let tempTableData = [...tableData]
  if (contactsSearch !== '') {
    tempTableData = tempTableData.filter(
      item =>
        item.Name.toLowerCase().includes(contactsSearch.toLowerCase()) ||
        item.Title.toLowerCase().includes(contactsSearch.toLowerCase()),
    )
  }
  if (currentStatus === 'Replied') {
    tempTableData = tempTableData.filter(item => item.Replied)
  } else if (currentStatus === 'Opened') {
    tempTableData = tempTableData.filter(item => item.Opened)
  }
  if (!isActiveUser) {
    tempTableData = tempTableData.filter(item => item['Added By'] !== 'User')
  }
  if (!isActiveCompany) {
    tempTableData = tempTableData.filter(item => item['Added By'] !== 'Maverick')
  }

  // Chart Collapse
  const [isChartOpened, setisChartOpened] = useState(false)

  return (
    <div className={classes.rootTab}>
      {selectedManeuver.sentEmails === 0 ? (
        <main className={classes.content}>
          <Container maxWidth="lg" className={classes.container}>
            <h4>
              It appears you have no data to report on, try changing your date range or contacting
              support.
            </h4>
          </Container>
        </main>
      ) : (
        <main className={classes.content}>
          <div className="black-title-section">
            <p className="black-title">SELECTED INTEL REPORT</p>
            <Tooltip title={`Click to ${isChartOpened ? 'collapse' : 'open'} charts`}>
              <span>
                <Button onClick={() => setisChartOpened(old => !old)}>
                  {isChartOpened ? (
                    <FaChevronUp style={{ color: '#fff' }} />
                  ) : (
                    <FaChevronDown style={{ color: '#fff' }} />
                  )}
                </Button>
              </span>
            </Tooltip>
          </div>
          <Grid container className={classes.prospectContainer}>
            {isChartOpened ? (
              <>
                <Grid item xs={4} md={4} lg={3}>
                  <Paper className={fixedHeightPaper}>
                    {selectedManeuver.sentEmails !== 0 ? (
                      <MyContact
                        data={myContactData}
                        title={`${selectedManeuver?.addedProspects} NEW`}
                      />
                    ) : null}
                  </Paper>
                </Grid>
                <Grid item xs={12} md={8} lg={3}>
                  <Paper className={fixedHeightPaper}>
                    {selectedManeuver.sentEmails !== 0 ? (
                      <EmailOpened
                        title={`${selectedManeuver.sentEmails} EMAILS SENT`}
                        data={emailsSentData}
                      />
                    ) : null}
                  </Paper>
                </Grid>
                <Grid item xs={4} md={4} lg={3}>
                  <Paper className={fixedHeightPaper}>
                    {selectedManeuver.sentEmails !== 0 ? (
                      <MyContact data={myRepliesData} title={`${getReplyTotalCount()} Replied`} />
                    ) : null}
                  </Paper>
                </Grid>
                <Grid item xs={12} md={8} lg={3}>
                  <Paper className={clsx(classes.graph, classes.fixedHeight)}>
                    {selectedManeuver.sentEmails !== 0 ? (
                      <EmailOpened
                        title={`${selectedManeuver.openData.reduce(
                          (a, b) => a + (b.opened || 0),
                          0,
                        )} EMAILS OPENED`}
                        data={emailsOpenedData}
                      />
                    ) : null}
                  </Paper>
                </Grid>
              </>
            ) : null}
            <Grid item xs={12}>
              <Paper className={clsx(classes.paper, classes.noBorder)}>
                {selectedManeuver.sentEmails !== 0 ? (
                  <Orders
                    isChartOpened={isChartOpened}
                    title={title}
                    data={tempTableData}
                    settings={settings}
                    setCurrentUser={setCurrentUser}
                    setTypeProp={setTypeProp}
                    setselectedLeadsEmails={setselectedLeadsEmails}
                    setOpenActions={setOpenActions}
                  />
                ) : null}
              </Paper>
            </Grid>
          </Grid>
        </main>
      )}
    </div>
  )
}
export default Report
